var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cursorWrap"},[_c('div',{staticClass:"cursor",style:({ left: _vm.cLeft + 'px', top: _vm.cTop + 'px' })}),_c('div',{staticClass:"cursor-follower",style:({ left: _vm.cLeft + 'px', top: _vm.cTop + 'px' })})])}
var staticRenderFns = []

export { render, staticRenderFns }